import React, { useMemo, useState, useCallback } from "react";
import ItineraryIcon from "../stop-finder/ItineraryIcon";
import ItineraryInfoCard from "./ItineraryInfoCard";
import { useTranslate } from "../../translate";
import { useElementQueries } from "./utils";
import { AnimatePresence, motion } from "framer-motion";
import Fade from "components/animations/Fade";
import { createPortal } from "react-dom";
import { motionTransition, popupVariants } from "../stop-finder/Header";
import { useMountedState } from "react-use";
import { getDaysCount, getDistance } from "./utils";

const containerSizes = [500];

function ItinerarySwitcherPopup(props) {
    const { routeItineraries, itinerary, onItineraryIdChange, onClose, isOpenItinerarySwitcher } = props;
    const isMounted = useMountedState();
    const [itineraryIdSelected, setItineraryIdSelected] = useState(null);
    const translate = useTranslate();
    const [ref, { attrs }] = useElementQueries(containerSizes);
    const currentItineraryDays = useMemo(() => getDaysCount(itinerary), [itinerary]);
    const currentItineraryDistance = useMemo(() => getDistance(itinerary), [itinerary]);
    const onChange = useCallback(event => {
        setItineraryIdSelected(event.target.value);
    }, []);
    const onSubmit = () => {
        window.scrollTo({
            left: 0,
            top: 0,
        });
        onClose();
        setItineraryIdSelected(null);
        onItineraryIdChange(itineraryIdSelected);
    };
    if (!itinerary) {
        return null;
    }
    return (
        <div className="trpr-itinerary-switcher-popup" ref={ref} {...attrs}>
            {isMounted &&
                createPortal(
                    <AnimatePresence initial={true}>
                        {isOpenItinerarySwitcher && (
                            <motion.div
                                onClick={onClose}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={motionTransition}
                                className="trpr__primary-layout-overlay"
                            />
                        )}
                    </AnimatePresence>,
                    document.querySelector(".js-primary-layout"),
                )}
            <AnimatePresence initial={true}>
                {isOpenItinerarySwitcher && (
                    <Fade key="active" transition={motionTransition}>
                        <div className="trpr-itinerary-switcher-popup__header">
                            <div className="trpr-itinerary-switcher-popup__header-title">
                                <ItineraryIcon></ItineraryIcon>
                                <span>Change Itinerary</span>
                            </div>
                            <button
                                onClick={onClose}
                                type="button"
                                className="trpr-itinerary-switcher-popup__header-close"
                            >
                                <i className="trpr__icon-close"></i>
                            </button>
                        </div>
                    </Fade>
                )}
            </AnimatePresence>
            <AnimatePresence initial={true}>
                {isOpenItinerarySwitcher && (
                    <motion.div
                        className="trpr-itinerary-switcher-popup__content"
                        variants={popupVariants}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        transition={motionTransition}
                    >
                        <div className="trpr-itinerary-switcher-popup__content-header">
                            <div className="trpr-itinerary-switcher-popup__content-label">
                                <span>Current Itinerary</span>
                            </div>
                            <div>
                                <ItineraryInfoCard
                                    title={translate(itinerary.metadata, "name")}
                                    days={currentItineraryDays}
                                    stops={itinerary.stops.length}
                                    distance={currentItineraryDistance}
                                    travelType={itinerary.metadata.type?.name}
                                    isGreen={true}
                                />
                            </div>
                        </div>
                        <div className="trpr-itinerary-switcher-popup__content-body">
                            <div className="trpr-itinerary-switcher-popup__content-label">
                                <span>Other Itineraries</span>
                            </div>
                            <div>
                                {routeItineraries &&
                                    routeItineraries.map(itinerary => {
                                        return (
                                            <ItineraryInfoCard
                                                key={itinerary.id}
                                                title={translate(itinerary, "name")}
                                                days={itinerary.days}
                                                stops={itinerary.totalStops}
                                                distance={itinerary.distance}
                                                travelType={translate(itinerary, "type.name")}
                                                value={itinerary.id}
                                                onChange={onChange}
                                                checked={itineraryIdSelected === itinerary.id}
                                            />
                                        );
                                    })}
                            </div>
                        </div>
                        <div className="trpr-itinerary-switcher-popup__content-footer">
                            <button onClick={onClose} type="button" className="trpr__n-btn-secondary-b trpr__btn-48">
                                Cancel
                            </button>
                            <button
                                onClick={onSubmit}
                                disabled={!itineraryIdSelected}
                                type="button"
                                className="trpr__n-btn-primary-b trpr__btn-48"
                            >
                                Change Itinerary
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default ItinerarySwitcherPopup;
